import { AppServiceApi } from 'mnvm-mypage-app-ts-if'
import { config } from './api-config'

export const appServiceApi = new AppServiceApi(config)
